import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, Grid, Icon, Popup} from 'semantic-ui-react';
import {Actions} from '../../../common/actions';
import PartModels from '../common/partModels';
import PartEquivalences from '../common/partEquivalences';
import PartSubstitutes from '../common/partSubstitute';
import PartMovements from './partMovements';


class PartInfo extends Component {
  constructor(props) {
    super(props);
    this.state = { };
    this.handleCloseClick = this.handleCloseClick.bind(this);
  }

  handleCloseClick() {
    this.props.hideOrderPartDetails();
  }

  renderSubstitutes(partCode) {
    if (!this.props.showSubstitutes) {
      return null;
    }

    return (
      <Grid.Row>
        <Grid.Column width='8'>
          <PartEquivalences partCode={partCode} />
        </Grid.Column>
        <Grid.Column width='8'>
          <PartSubstitutes partCode={partCode} />
        </Grid.Column>
      </Grid.Row>
    );
  }

  renderHeader(partCode, partName) {
    const {partIndex, rowsCount} = this.props;

    if (partIndex !== null) {
      return (
        <h3>Línea {partIndex + 1} de {rowsCount} | {partCode} - {partName} {this.tooltipWeekInformation()}</h3>
      );
    }

    return (<h3>{partCode} - {partName} {this.tooltipWeekInformation()}</h3>);
  }

  tooltipWeekInformation() {
    return (
      <Popup
        trigger={
          <Icon link name='info circle' color='blue' size='large' />
        }
        on='click'
        position='bottom left'
        inverted
      >
        <div>
          Siendo:
          <br />
          S1: La semana más antigua
          <br/>
          S24: La semana más reciente
        </div>
      </Popup>
    );
  }

  render() {
    const {partCode, partName} = this.props;

    if (!partCode || !partName) {
      return null;
    }

    return (
      <Card raised fluid className='part-info-section' >
        <Grid>
          <Grid.Row>
            <Grid.Column width='8'>
              {this.renderHeader(partCode, partName)}
            </Grid.Column>
            <Grid.Column width='8' textAlign='right'>
              <strong>
                <Icon link
                  size='big'
                  name='close'
                  color='blue'
                  onClick={this.handleCloseClick}
                />
              </strong>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width='11' className='movements-chart-container'>
              <PartMovements partCode={partCode} />
            </Grid.Column>
            <Grid.Column width='5'>
              <PartModels partCode={partCode} size='medium' />
            </Grid.Column>
          </Grid.Row>
          {this.renderSubstitutes(partCode)}
        </Grid>
      </Card>
    );
  }
}

const mapStateToProps = (state) => {
  const {partIndex, partName, partCode, filteredOrders = []} = state.providerStockOrders;

  return {partIndex, partCode, partName, 'rowsCount': filteredOrders.length};
};

const {
  hideOrderPartDetails,
} = Actions;

export default connect(mapStateToProps, {
  hideOrderPartDetails,
})(PartInfo);
